import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import DocumentsSection from "../../components/pages/documents/DocumentsSection";

export function Documents() {

    return (
        <PageContainerAuth section="mailings-attachs" pageTitle="Pièces jointes">
            <DocumentsSection/>
        </PageContainerAuth>
    );
}